import { render, staticRenderFns } from "./CallCheck.vue?vue&type=template&id=70a2b934&scoped=true&"
import script from "./CallCheck.vue?vue&type=script&lang=js&"
export * from "./CallCheck.vue?vue&type=script&lang=js&"
import style0 from "./CallCheck.vue?vue&type=style&index=0&id=70a2b934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2b934",
  null
  
)

export default component.exports